import { IFC_CLASSES_CEILING_DEVICES } from "../deviceCategoryConfig";
import { parseAllCeilingGrids } from "./ceilingUtils";
const isPoint2D = (point) => Array.isArray(point) &&
    point.length >= 2 &&
    typeof point[0] === "number" &&
    typeof point[1] === "number" &&
    Number.isFinite(point[0]) &&
    Number.isFinite(point[1]);
const to2DPoints = (points) => (points ?? []).filter(isPoint2D).map((point) => [point[0], point[1]]);
const getItemBoundingBox = (item) => to2DPoints(item.bboxSnapshot?.bbox ?? item.bbox);
const getCenter = (points) => {
    if (points.length === 0)
        return null;
    const sum = points.reduce((acc, point) => [acc[0] + point[0], acc[1] + point[1]], [0, 0]);
    return [sum[0] / points.length, sum[1] / points.length];
};
const isPointInsidePolygon = (point, polygon) => {
    if (polygon.length < 3)
        return false;
    const [x, y] = point;
    let inside = false;
    for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
        const [xi, yi] = polygon[i];
        const [xj, yj] = polygon[j];
        const intersects = yi > y !== yj > y && x < ((xj - xi) * (y - yi)) / (yj - yi) + xi;
        if (intersects)
            inside = !inside;
    }
    return inside;
};
const isCeilingDeviceItem = (item) => IFC_CLASSES_CEILING_DEVICES.includes(item.instanceClass);
const getTileKey = (gridIndex, rowIndex, columnIndex) => `${gridIndex}:${rowIndex}:${columnIndex}`;
export function getCeilingFreeTileBoundingBoxes(args) {
    const ceilingItemCenters = args.mcbimItems
        .filter(isCeilingDeviceItem)
        .map(getItemBoundingBox)
        .map(getCenter)
        .filter((center) => center != null);
    const ceilingGrids = parseAllCeilingGrids(args.ceilingGrids);
    const occupiedTileKeys = new Set();
    ceilingItemCenters.forEach((center) => {
        ceilingGrids.forEach((gridTiles, gridIndex) => {
            gridTiles.forEach((row, rowIndex) => {
                row.forEach((tile, columnIndex) => {
                    const tileBoundingBox = to2DPoints(tile.boundingBox);
                    if (tileBoundingBox.length < 3)
                        return;
                    if (!isPointInsidePolygon(center, tileBoundingBox))
                        return;
                    occupiedTileKeys.add(getTileKey(gridIndex, rowIndex, columnIndex));
                });
            });
        });
    });
    return ceilingGrids.flatMap((gridTiles, gridIndex) => gridTiles.flatMap((row, rowIndex) => row.flatMap((tile, columnIndex) => {
        const tileBoundingBox = to2DPoints(tile.boundingBox);
        if (tileBoundingBox.length < 3)
            return [];
        if (occupiedTileKeys.has(getTileKey(gridIndex, rowIndex, columnIndex)))
            return [];
        return [
            {
                gridIndex,
                rowIndex,
                columnIndex,
                boundingBox: tileBoundingBox,
            },
        ];
    })));
}
